import type { PredictionContractListResponse, PredictionProductsResponse } from '@/types/prediction.types';
import { getMeasuredPeriodYear } from '@/utils/forecastExExpirations';

// FORECASTUI-3008: KXBALANCEPOWERCOMBO settles in 2027 but belongs to the 2026 election.
const BALANCE_OF_POWER_KALSHI_PRODUCT_CONID = 853714026;
const BALANCE_OF_POWER_FORECASTX_PRODUCT_CONID = 800591714;
const KALSHI = 'KALSHI';

function overrideElectionPeriod<T extends { measured_period?: string }>(contract: T): T {
  return getMeasuredPeriodYear(contract.measured_period?.trim()) === '2027'
    ? { ...contract, measured_period: '2026' }
    : contract;
}

export function overrideProductMeasuredPeriods(response: PredictionProductsResponse): PredictionProductsResponse {
  return {
    ...response,
    complex_products: response.complex_products.map((product) => {
      const isTargetProduct = product.products.some(
        (venue) =>
          (venue.conid === BALANCE_OF_POWER_KALSHI_PRODUCT_CONID && venue.exchange === KALSHI) ||
          (venue.conid === BALANCE_OF_POWER_FORECASTX_PRODUCT_CONID && venue.exchange === 'FORECASTX'),
      );
      if (!isTargetProduct) return product;

      // Product responses identify venues at product level, not on each strike's contract pair.
      return {
        ...product,
        complex_contracts: product.complex_contracts.map((contract) =>
          contract.contracts.some((venue) => venue.exchange === KALSHI) ? overrideElectionPeriod(contract) : contract,
        ),
      };
    }),
  };
}

export function overrideContractListMeasuredPeriods(
  response: PredictionContractListResponse,
): PredictionContractListResponse {
  return {
    ...response,
    complex_contracts: response.complex_contracts.map((contract) => {
      const isTargetProduct = contract.contracts.some(
        (venue) => venue.product_conid === BALANCE_OF_POWER_KALSHI_PRODUCT_CONID && venue.exchange === KALSHI,
      );
      return isTargetProduct ? overrideElectionPeriod(contract) : contract;
    }),
  };
}
// last modified by AI tools on 2026-10-26
